import { Descriptions } from 'antd';
import React from 'react';

const EXIFTable = (props) => {
    const photo = props?.photo

    const tableContent = [
        {
            key: "1",
            label: "Camera",
            children: <p>{photo.camera_make} {photo.camera_model}</p>
        },
        {
            key: "2",
            label: "Lens",
            children: <p>{photo.lens_model}</p>
        },
        {
            key: "3",
            label: "Focal Length",
            children: <p>{(photo.focal_absolute !== -1)? photo.focal_absolute : "(No data)"} {(photo.focal_equivalent !== photo.focal_absolute)? `(${photo.focal_equivalent} equivalent)` : "" }</p>
        },
        {
            key: "4",
            label: "ISO",
            children: <p>{photo.exposure_iso}</p>
        },
        {
            key: "5",
            label: "F Stop",
            children: <p>{(photo.exposure_fstop !== -1)? photo.exposure_fstop : "(No data)"}</p>
        },
        {
            key: "6",
            label: "Exposure Time",
            children: <p>{(photo.exposure_time !== -1)? photo.exposure_time : "(No data)"}</p>
        },
        {
            key: "7",
            label: "Program",
            children: <p>{photo.exposure_program}</p>
        },
        {
            key: "8",
            label: "Flash",
            children: <p>{photo.exposure_flash}</p>
        },
    ]



    return (
        <div style={{color: "#ffffff"}}>
        <Descriptions
            items={tableContent}
            bordered
            size="small"
            column={1}
            contentStyle={{color: "#ffffff", backgroundColor: "#1a1a1a70"}}
            labelStyle={{color: "#e0e0e0", fontWeight: "bold", backgroundColor: "#1a1a1a90"}}
        >

        </Descriptions>
        </div>
    )
}

export default EXIFTable;